import { render } from "./chatToPatient.vue?vue&type=template&id=8c48bb64&scoped=true"
import script from "./chatToPatient.vue?vue&type=script&lang=js"
export * from "./chatToPatient.vue?vue&type=script&lang=js"

import "./chatToPatient.vue?vue&type=style&index=0&id=8c48bb64&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c48bb64"]])

export default __exports__